module.exports = __webpack_public_path__ + "img/typehoon50.00b26d74.png";